export const blockIconsMapsFactoryNew = (
	<span className='material-symbols-outlined'>factory</span>
);
